import React from "react";
import {
  // HiXCircle,
  BiUnlink,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/bi";
import { useTranslation } from "react-i18next";

export default function UnConnectMargins(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        } ${
          props.shouldShowButtonLabels ? " show-label-top-menu " : ""
          }`}
        onClick={props.onClickHandler}
        title={t("Unlink")}
      >
        <span className="icon icon-tema-color is-small has-text-light">
          <BiUnlink className="fas fa-2x" />
        </span>
        {props.shouldShowButtonLabels && <span className=" mr-1 show-label-text">{t("Unlink")}</span>}
      </button>
    </>
  );
}
